"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6658],{

/***/ 46658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionServicesListing": function() { return /* binding */ SectionServicesListing; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61349);




const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    color: "$white",
    paddingTop: "96",
    "@lg": {
        paddingTop: "$144"
    }
});
const Content = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    margin: "0 auto",
    containerSpace: "medium",
    width: "100%"
});
const SectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h2", {});
const ServiceGroupTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    display: "block",
    projectFont: "heading08",
    marginBottom: "$40"
});
const ServicesBlocksList = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("ul", {
    display: "grid",
    listStyleType: "none",
    gap: "$40 $0",
    gridTemplateColumns: "1fr",
    "@media (min-width: 675px)": {
        gridTemplateColumns: "repeat(2, 1fr)"
    },
    "@lg": {
        gridTemplateColumns: "repeat(4, 1fr)"
    }
});
const ServicesList = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("ul", {
    listStyleType: "none",
    display: "grid",
    gap: "$8"
});
const LinkWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    marginTop: "$64",
    display: "flex",
    justifyContent: "center",
    "@media (min-width: 675px)": {
        justifyContent: "flex-start"
    }
});
const SectionServicesListing = (param)=>{
    let { cta , ctaLabel , servicesList  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("servicesListing");
    if (!servicesList.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "NO_MARGIN",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                className: "sr-only",
                children: t("title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServicesBlocksList, {
                        children: servicesList === null || servicesList === void 0 ? void 0 : servicesList.map((servicesListItem, listIndex)=>{
                            var _servicesListItem_services;
                            const serviceGroupId = "service-group-".concat((servicesListItem === null || servicesListItem === void 0 ? void 0 : servicesListItem._key) || listIndex);
                            return (servicesListItem === null || servicesListItem === void 0 ? void 0 : servicesListItem.services) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    (servicesListItem === null || servicesListItem === void 0 ? void 0 : servicesListItem.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServiceGroupTitle, {
                                        id: serviceGroupId,
                                        children: servicesListItem === null || servicesListItem === void 0 ? void 0 : servicesListItem.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServicesList, {
                                        "aria-labelledby": (servicesListItem === null || servicesListItem === void 0 ? void 0 : servicesListItem.title) ? serviceGroupId : undefined,
                                        children: servicesListItem === null || servicesListItem === void 0 ? void 0 : (_servicesListItem_services = servicesListItem.services) === null || _servicesListItem_services === void 0 ? void 0 : _servicesListItem_services.map((service, serviceIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Pill */ .DR, {
                                                    appearance: "UI05",
                                                    children: service
                                                })
                                            }, service ? "".concat(service, "-").concat(serviceIndex) : "service-".concat(serviceIndex)))
                                    })
                                ]
                            }, (servicesListItem === null || servicesListItem === void 0 ? void 0 : servicesListItem._key) || serviceGroupId) : null;
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkWrap, {
                        children: cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                            ...cta,
                            appearance: "containedTransparent",
                            children: ctaLabel
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);